import React from "react";
import ServiceSectionComponent from "./ServiceSectionComponent";

const ServiceSection = ({ isHide, services }) => {
  return (
    <>
      <ServiceSectionComponent isHide={isHide} services={services} />
      {/* <Hidden mdDown>
        <PartnerSection />
      </Hidden>
      <Hidden mdUp>
        <MobilePartnerSection />
      </Hidden> */}
    </>
  );
};

export default ServiceSection;
